<div class="header p-2">
  <img class="icon mr-1 float-left" src="assets/icons/ui-date-year-previous.svg" alt="vorig jaar" (click)="previousClicked('year')" />
  <img class="icon mr-1 float-left" src="assets/icons/ui-date-month-previous.svg" alt="vorige maand" (click)="previousClicked('month')" />

  <div class="text">{{ periodLabel }}</div>

  <img class="icon ml-1" src="assets/icons/ui-date-month-next.svg" alt="volgende maand" (click)="nextClicked('month')" />
  <img class="icon ml-1" src="assets/icons/ui-date-year-next.svg" alt="volgend jaar" (click)="nextClicked('year')" />

  <!-- 	<button mat-icon-button class="example-double-arrow"
      (click)="previousClicked('year')">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="previousClicked('month')">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <span class="example-header-label">{{periodLabel}}</span>
    <button mat-icon-button (click)="nextClicked('month')">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
    <button mat-icon-button class="example-double-arrow"
      (click)="nextClicked('year')">
      <mat-icon>keyboard_arrow_right</mat-icon>
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button> -->
</div>
